export enum QualificationStatus {
    Unknown = 'Unknown',
    Rejected = 'Rejected',
    Qualified = 'Qualified',
    Abandoned = 'Abandoned'
}